import { Log } from '@lightningjs/sdk';
import { DetailAction } from './DetailAction';
import { Backend } from '../../../api/Backend';
import { AssetType } from '../../../api/models/Shared.types';

export class FavouriteAction extends DetailAction {
  private _id: string;
  private _type: AssetType;
  private _adult: boolean;
  private _cb: any;
  private _favouriteState: boolean;
  constructor(backend: Backend, id: string, type: AssetType, adult: boolean, stateChangeCallback: any) {
    super(backend);
    this._backend = backend;
    this._id = id;
    this._type = type;
    this._adult = adult;
    this._cb = stateChangeCallback;

    this._favouriteState = false;
    this._backend.cachedFavoriteApi
      .isFavorite(this._backend, {
        id: this._id,
        type: this._type,
      })
      .then(result => {
        this._state = result;
      });
  }

  set _state(val: boolean) {
    this._favouriteState = val;
    this._cb && this._cb(val);
  }

  get state() {
    return this._favouriteState;
  }

  override doAction() {
    this.updateFavourite();
  }

  updateFavourite() {
    const removeFav = this._favouriteState;
    const originalstate = this._favouriteState;
    if (removeFav) {
      this._state = false;
      this._backend.cachedFavoriteApi.deleteFavorite(this._backend, { id: this._id, type: this._type }).catch(() => {
        Log.error('[SharedFavouriteActionButton]', 'error removing favourite');
        this._state = originalstate;
      });
    } else {
      this._state = true;
      this._backend.cachedFavoriteApi
        .setFavorite(
          this._backend,
          {
            id: this._id,
            type: this._type,
          },
          this._adult
        )
        .catch(() => {
          Log.error('[SharedFavouriteActionButton]', 'error adding favourite');
          this._state = originalstate;
        });
    }
  }
}
